module.exports = __webpack_public_path__ + "static/media/Retiros.680622c8.png";